<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
   [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<br>

<div class="container">
   <div class="row justify-content-end" style="margin-top: 2%;">
      <div class="col-md-8 offset-md-4">
         <div class="row">
            <div class="col-md-4">
               <tc-form-group>
                  <button class="button-btn"
                     (click)="openModals_addon(Body, Header,Footer,{ closeButton: true, overlayClose: false , width: 600 })">
                     <tc-icon [iconClass]="'icofont-plus-circle'" [tcFontSize]="22" [tcColor]="['#fffff', '#fffff']"
                        title="Add on" style="margin-top: -5px !important;"></tc-icon> &nbsp;
                     Add on
                  </button>
               </tc-form-group>
            </div>
         </div>
      </div>
   </div>
 <ng-container *ngIf ="addon_details.length ==0" >
   <p class="addon_text_main">Add-ons not found</p>
</ng-container>
<ng-container *ngIf ="addon_details.length !=0"> 
   <tc-table [rows]="addon_details" [search]="true" [hovered]="true" [pagination]="true" [headerBgColor]="'#fb8033'"
      [headerColor]="'#ffffff'" [headerBgColor]="'#3e51b5'">
      <tc-table-col [columnTitle]="'S.No.'" [columnName]="'id'">
         <ng-template #tableTDTemplate let-value>
        {{value}}
         </ng-template>
      </tc-table-col>
      <tc-table-col [columnTitle]="'Add On Name'" [columnName]="'addon_name'">
         <ng-template #tableTDTemplate let-value>
            {{value}}
         </ng-template>
      </tc-table-col>
      <tc-table-col [columnTitle]="'Allergens'" [columnName]="'restaurant_addon_allegens'">
       <ng-template #tableTDTemplate let-value>
      {{checkALlergens(value)}}
      </ng-template>    
      </tc-table-col>
      <tc-table-col [columnTitle]="'Unsuitable Dietary Preference'" [columnName]="'restaurant_addon_dietary'">
         <ng-template #tableTDTemplate let-value>
               {{checkdietary(value)}}
         </ng-template>
      </tc-table-col>
      <tc-table-col [columnTitle]="'Details'" [columnName]="''">
         <ng-template #tableTDTemplate let-value="row">
            <button tc-button [afterIcon]="'icofont-eye-alt'" [tcFontSize]="10" [tcBgColor]="'#2f8c00'" [square]="true"
               [tcShape]="500" [size]="'sm'"
               (click)="openModalsView_detail(modalBodyview, modalHeaderview,modalFooterview,{ width: 800 },value.addon_name)"></button>
         </ng-template>
      </tc-table-col>
      <tc-table-col [columnTitle]="'Status'" [columnName]="'addon_status'">
         <ng-template #tableTDTemplate let-value="row">
            <tc-switcher *ngIf="value.addon_status =='Inactive'"
               (click)="switch_toggle('Active',value.id)" [value]="false" [tcFontSize]="10"
               #templateForm></tc-switcher>
            <tc-switcher *ngIf="value.addon_status =='Active'" [tcFontSize]="10"
               (click)="switch_toggle('Inactive',value.id)" [value]="true" #templateForm>
            </tc-switcher>
         </ng-template>
      </tc-table-col>
      <tc-table-col [columnTitle]="'Delete'" [columnName]="'id'">
         <ng-template #tableTDTemplate let-value="row">
            <button tc-button [afterIcon]="'icofont-ui-delete'" [tcFontSize]="10" [view]="'error'" [square]="true"
               [tcShape]="500" [size]="'sm'"
               (click)="openModals_delete(Delete_Body, Delete_Header,Delete_Footer,{ closeButton: true, overlayClose: false ,width: 500 },value.addon_name)"></button>
         </ng-template>
      </tc-table-col>
   </tc-table>
</ng-container>
</div>

<ng-container>
   <ng-template #Header>
      <h2 class="title">Create Add On</h2>
   </ng-template>
   <ng-template #Body>
      <form novalidate #heroForm="ngForm" class="new-patient-form">
         <div class="row">
            <div class="col-md-4">
               <tc-form-group>
                  <label for="addon_name" class="fnt-wght">Add On Name</label>
                  <tc-input  placeholder="Name"  [(ngModel)]="addon_name" [ngModelOptions]="{standalone: true}"
                     required>
                  </tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="allergens" class="fnt-wght">Allergens</label>
                  <ng-select [(ngModel)]="alrgoption" name="alrgoption" [items]="allergens" bindLabel="allergens_name"
                     bindValue="allergens_id" [multiple]="true" [virtualScroll]="true" placeholder="Select allergens" required>
                  </ng-select>
               </div>
            </div>

            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="dietPref" class="fnt-wght">Unsuitable Dietary Preference</label>
                  <ng-select [(ngModel)]="dietPref" name="allDiestpref" [items]="allDiestpref"
                     bindLabel="diet_preference_name" bindValue="diet_preference_id" [multiple]="true"
                     [virtualScroll]="true" placeholder="Select dietary Preference" required>
                  </ng-select>
               </div>
            </div>
         </div>
      </form>
   </ng-template>
   <ng-template #Footer>
      <div class="actions">
         <button tc-button [view]="'info'" [disabled]="!addon_name || !alrgoption || !dietPref "
            (click)="Creat_addon(addon_name,alrgoption,dietPref)">Add</button>
      </div>
   </ng-template>
</ng-container>


<ng-container>
   <ng-template #modalHeaderview>
      <h2 class="title">Add On Details</h2>
      <div class="actions nowrap" *ngFor="let item of detail_addon">
         <button tc-button [afterIcon]="'icofont-ui-edit'" [view]="'info'" [tcFontSize]="10" [square]="true"
            [tcShape]="500" [size]="'sm'"
            (click)="Edit_Modals(Edit_Body, Edit_Header,Edit_Footer,{ width: 600 },item.id)"></button>
      </div>
   </ng-template>
   <ng-template #modalBodyview>
      <form novalidate #heroForm="ngForm" class="new-patient-form">
         <div class="row" *ngFor="let item of detail_addon">
            <div class="col-md-4">
               <tc-form-group>
                  <label for="item.restaurant_addon_name" class="fnt-wght">Add On Name</label>
                  <tc-input disabled  placeholder="Name"  [(ngModel)]="item.addon_name"
                     [ngModelOptions]="{standalone: true}" required>
                  </tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group>
                  <label for="addonDietary" class="fnt-wght">Allergens</label>
                  <tc-input disabled [placeholder]="'Allergens'" [(ngModel)]="addonAllergen"
                     [ngModelOptions]="{standalone: true}" required></tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <tc-form-group>
                  <label for="addonDietary" class="fnt-wght">Unsuitable Dietary Preference</label>
                  <tc-input disabled [placeholder]="'Unsuitable Dietary Preference'" [(ngModel)]="addonDietary"
                     [ngModelOptions]="{standalone: true}" required></tc-input>
               </tc-form-group>
            </div>
         </div>
      </form>
   </ng-template>
   <ng-template #modalFooterview>
      <div class="actions">
         <button tc-button [type]="'button'" [view]="'error'" (click)="close_Details()">Close</button>
      </div>
   </ng-template>
</ng-container>


<ng-container>
   <ng-template #Edit_Header>
      <h2 class="title">Edit Add On</h2>
   </ng-template>
   <ng-template #Edit_Body>
      <form novalidate #heroForm="ngForm" class="new-patient-form" *ngFor="let item of detail_addon">
         <div class="row">
            <div class="col-md-4">
               <tc-form-group>
                  <label for="addon_name" class="fnt-wght">Add On Name</label>
                  <tc-input placeholder="Name"  [(ngModel)]="addon_name " [ngModelOptions]="{standalone: true}"
                     required>
                  </tc-input>
               </tc-form-group>
            </div>
            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="allergens" class="fnt-wght">Allergens</label>
                  <ng-select [(ngModel)]="addonAllergen" name="alrgoption" [items]="allergens"
                     bindLabel="allergens_name" bindValue="allergens_id" [multiple]="true" [virtualScroll]="true"
                     placeholder="Allergens" required>
                  </ng-select>
               </div>
            </div>

            <div class="col-md-4">
               <div class="col-md-12 col-sm-6" class="paddbottom3">
                  <label for="dietPref" class="fnt-wght">Unsuitable Dietary Preference</label>
                  <ng-select [(ngModel)]="addonDietary" name="allDiestpref" [items]="allDiestpref"
                     bindLabel="diet_preference_name" bindValue="diet_preference_id" [multiple]="true"
                     [virtualScroll]="true" placeholder="Dietary Preference" required>
                  </ng-select>
               </div>
            </div>
         </div>
      </form>
   </ng-template>
   <ng-template #Edit_Footer>
      <div class="actions">
         <button tc-button [type]="'button'" [view]="'error'" (click)="close_edit()">Close</button>&nbsp;
         <button tc-button [view]="'info'"
            (click)="Update_addon(addon_name,addonAllergen,addonDietary)">Update</button>
      </div>
   </ng-template>
</ng-container>
<ng-container>
   <ng-template #Delete_Header>
      <h2 class="title">Delete</h2>
   </ng-template>
   <ng-template #Delete_Body>
      <p style="font-size: 20px;">Are you sure you want to delete this Add-ons?</p>
   </ng-template>
   <ng-template #Delete_Footer>
      <div class="actions">
         <button tc-button [view]="'warning'" (click)="delete_addon()">Delete</button>
      </div>
   </ng-template>
</ng-container>